import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxColModule } from '@nrwl/rx-col';
import { RxPipesModule } from '@nrwl/rx-pipes';
import { RxVideoCompositeComponent } from './rx-video-composite.component';

@NgModule({
  imports: [CommonModule, RxColModule, RxPipesModule, RxVideoCompositeComponent],
  exports: [RxVideoCompositeComponent],
})
export class RxVideoCompositeModule {}
